import { Http } from '@zhfe/common-library'
import { Injectable } from '@tanbo/vue-di-plugin'
import { FastLoginResponseData } from '../login.service'

/**
 * 微信网站应用登录
 */
export interface WxWebLoginParams {
  /** 微信回跳带回的 code，单次有效 */
  code: string
  meta: {
    /** 前端生成的 state，用于防 CSRF；目前仅前端校验，传给后端便于排查日志 */
    state: string
  }
}

@Injectable()
export class WxWebLoginService {
  constructor(private http: Http) {
  }

  /**
   * @description 用授权 code 换登录 token
   */
  requestWxWebLogin (params: WxWebLoginParams) {
    return this.http.post<FastLoginResponseData>('/account/login/wx_h5', params)
  }
}
